import { Capacitor, CapacitorCookies } from '@capacitor/core'

const COOKIE_URL = 'https://localhost'
const ONE_YEAR = 60 * 60 * 24 * 365

interface SetCookieOptions {
	maxAgeSeconds?: number // in seconds, defaults to 1 year
}

export function useCookie() {
	
	async function getCookie(name: string): Promise<string | null> {
		const encodedName = encodeURIComponent(name)
		
		if (Capacitor.isNativePlatform()) {
			const cookies = await CapacitorCookies.getCookies({ url: COOKIE_URL })
			const raw = (cookies as Record<string, string>)[encodedName] ?? null
			return raw ? decodeURIComponent(raw) : null
		}

		const raw = document.cookie
				.split('; ')
				.find(row => row.startsWith(encodedName + '='))
				?.split('=')[1] ?? null
		return raw ? decodeURIComponent(raw) : null
	}

	async function setCookie(name: string, value: string, options: SetCookieOptions = {}): Promise<void> {
		const maxAgeSeconds = options.maxAgeSeconds ?? ONE_YEAR

		const encodedName = encodeURIComponent(name)
		const encodedValue = encodeURIComponent(value)

		if (Capacitor.isNativePlatform()) {
			await CapacitorCookies.setCookie({
				url: COOKIE_URL,
				key: encodedName,
				value: encodedValue,
				expires: new Date(Date.now() + maxAgeSeconds * 1000).toUTCString()
			})
			return
		}

		document.cookie = `${encodedName}=${encodedValue}; path=/; max-age=${maxAgeSeconds}`
	}

	async function deleteCookie(name: string): Promise<void> {
		const encodedName = encodeURIComponent(name)
		
		if (Capacitor.isNativePlatform()) {
			await CapacitorCookies.deleteCookie({ url: COOKIE_URL, key: encodedName })
			return
		}

		document.cookie = `${encodedName}=; path=/; max-age=0`
	}

	return { getCookie, setCookie, deleteCookie }
}